<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="none">
    <path
      d="M17 13L12 18L7 13M12 6L12 17"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
